import { Menu, PageFooter } from '@telia/styleguide';
import React from 'react';
import TeliaLogo from '../assets/telia-logo.png';
import './Menu.less';

const menuLinks = [
  {
    heading: { text: 'Privat', url: '#' },
    links: [
      {
        text: 'Nettbutikk',
        subLinks: [
          { text: 'Mobiltelefoner', url: 'https://www.telia.no/mobiltelefoner/' },
          { text: 'Smartklokker', url: 'https://www.telia.no/smartklokker/' },
          { text: 'Smarte hjem', url: 'https://www.telia.no/futurehome/' },
          { text: 'Nettbrett', url: 'https://www.telia.no/nettbrett/' },
          { text: 'Tilbehør', url: 'https://www.telia.no/mobiltilbehor/' }
        ]
      },
      { text: 'Mobilabonnement', url: 'https://www.telia.no/mobilabonnement/' },
      { text: 'TV', url: 'https://www.telia.no/tv' },
      { text: 'Internett', url: 'https://www.telia.no/internett' },
      { text: 'Kundeservice', url: 'https://www.telia.no/kundeservice' }
    ]
  },
  {
    heading: { text: 'Bedrift', url: 'https://www.telia.no/bedrift/' },
    links: [
      { text: 'Produkter og tjenester', url: 'https://www.telia.no/bedrift/produkter-og-tjenester/' },
      { text: 'Teknologi og samfunn, url', url: 'https://www.telia.no/bedrift/digitalisering/' },
      {
        text: 'Nettbutikk',
        subLinks: [
          { text: 'Mobiltelefoner', url: 'https://www.telia.no/bedrift/mobiltelefoner' },
          { text: 'Mobilabonnement', url: 'https://www.telia.no/bedrift/abonnement/telia-click/' },
          { text: 'Mibilt Bredbånd', url: 'https://www.telia.no/bedrift/mobilt-bredband/' }
        ]
      },
      { text: 'Kundeservice', url: 'https://www.telia.no/bedrift/kundeservice/' }
    ]
  }
];
const FooterLinks = [
  { text: 'Butikker og forhandlere', url: 'https://www.telia.no/butikk/' },
  { text: 'Borettslag', url: 'https://telia.no/borettslag' },
  { text: 'Nettbutikk', url: 'https://www.telia.no/mobiltelefoner/' },
  { text: 'Dekning', url: 'https://www.telia.no/dekning/' },
  { text: 'Om Telia', url: 'https://www.telia.no/om-telia/' },
  { text: 'Kontakt oss', url: 'https://www.telia.no/kontakt-oss/' }
];
const specialLink = { text: 'Personvern og Cookies', url: 'https://www.telia.no/personvern/' };

export const GlobalMenu = () => (
  <Menu
    loginUrl="#Menu"
    logoUrl="#"
    logoTitle="Telia logo"
    activeIndex={0}
    activeLinkIndex={-1}
    menuLinks={menuLinks}
    logoImageDesktopPath={TeliaLogo}
    mobileMenuCloseButtonLabel="Lukk"
    lockBodyOnMenuOpen
    isLoggedIn
    myPageUrl="#"
    dropdownMenu={{
      type: 'B2C',
      channel: 'tv-internet',
      visible: false
    }}
  />
);

export const GlobalFooter = () => <PageFooter links={FooterLinks} specialLink={specialLink} />;
